import { Component } from '@angular/core';
import {
  TextAnimationStep,
  TranslateDefinition,
  ZoomDefinition,
} from '../../element-editor/animation/text-animation.service';
import { Store } from '@ngrx/store';
import { selectCurrentTextAnimationStep } from '../../element-editor/store/selector/editor.selector';
import { cloneDeep } from 'lodash';
import { setFileDescriptorItem } from '../../element-editor/store/editor.actions';
import { CanvasService } from '../../services/canvas/canvas.service';
import { TextShape } from '../../element-editor/shape/shapes/text/text-shape';
import { isEqual } from 'lodash';
import { TextAnimationFrameObject } from './text-animation-step-frame';
import { ImageShape } from '../../element-editor/shape/shapes/base/image-shape';
import { FileRootShape } from '../../element-editor/shape/shapes/general/root/file-root-shape';
import { AnimationService } from '../../element-editor/animation/animation.service';

export type _TextAnimationStep = TextAnimationStep & { _paralell?: boolean };

@Component({
  selector: 'nw-text-animation-editor',
  templateUrl: './text-animation-editor.component.html',
  styleUrls: ['./text-animation-editor.component.scss'],
})
export class TextAnimationEditorComponent {
  // @Input() set step(value: TextAnimationStep | undefined) {
  //   this.model = value || this.model;
  // } // -- //
  // model: TextAnimationStep = {}; // -- // -- //
  steps: _TextAnimationStep[] = [];
  currentModelIndex = 0;
  // Frame graph state
  frameRoot?: TextAnimationFrameObject;
  // frames: TextAnimationFrameObject[] = []; // -- // -- //

  get frames() {
    return Object.values(this._frames);
  }
  currentFrame?: TextAnimationFrameObject;
  editing?: { node: TextAnimationFrameObject; draft: TextAnimationStep };
  baseStep: _TextAnimationStep;
  constructor(
    private readonly store: Store,
    private readonly cs: CanvasService,
    private readonly animationService: AnimationService,
  ) {
    this.store.select(selectCurrentTextAnimationStep).subscribe(step => {
      this.steps = [];
      if (!step) {
        this.baseStep = {};
        return;
      }

      // console.log('step', step);

      if (isEqual(step, this.baseStep)) {
        return;
      }

      this.baseStep = step;
      let currentStep = cloneDeep(step);
      while (currentStep) {
        if (currentStep.paralell) {
          // this.steps.push({
          //   ...currentStep.paralell,
          //   _paralell: true,
          // });
        } else {
          this.steps.push(currentStep);
        }
        currentStep = currentStep.next;
      }

      // rebuild frame graph for display
      this.rebuildFrames(step);
    });
  }

  save() {
    const steps = cloneDeep(this.steps);
    steps.reverse();
    const chain = steps.reduce((prev, step) => {
      if (!prev) {
        return step;
      }
      if (prev._paralell) {
        // -- // -- //
        step.paralell = prev;
        return step;
      }
      step.next = prev;
      return step;
    }, null);
    console.log('save', chain);

    this.store.dispatch(
      setFileDescriptorItem({
        key: 'textAnimationStep',
        value: chain,
      }),
    );

    this.textShape.reset();
    // this.cs.pre
  }

  get model() {
    return this.steps[this.currentModelIndex];
  }

  setIndex(index: number) {
    this.currentModelIndex = index;
  }

  // JSON modal state
  jsonOpen = false;
  openJson() {
    this.jsonOpen = true;
  }
  closeJson() {
    this.jsonOpen = false;
  }
  applyJson(updated: TextAnimationStep) {
    this.store.dispatch(
      setFileDescriptorItem({ key: 'textAnimationStep', value: updated }),
    );

    // (this.cs.previewShape as FileRootShape).descriptor.textAnimationStep =
    //   cloneDeep(updated) as TextAnimationStep;

    this.jsonOpen = false;
  }

  removeFrame(node: TextAnimationFrameObject) {
    node.remove();
    // -- // -- // -- // -- //
    // console.log('remove-frame', this.frameRoot?.frame); //
    this.store.dispatch(
      setFileDescriptorItem({
        key: 'textAnimationStep',
        value: this.frameRoot?.frame,
      }),
    );
  }

  get textShape() {
    const scene = this.cs.previewShape;
    const [textShape] = scene.shapes;

    if (!(textShape instanceof TextShape)) {
      return;
    }
    return textShape;
  }

  get imageShape() {
    const scene = this.cs.previewShape;
    const [imageShape] = scene.shapes;

    if (!(imageShape instanceof ImageShape)) {
      return;
    }
    return imageShape;
  }

  isPlaying = false;
  play() {
    if (!this.textShape && !this.imageShape) {
      return;
    }
    // -- //
    if (this.isPlaying) {
      return;
    }
    this.isPlaying = true;
    const step = this.playingStep;
    if (!step) return;

    this.animationService.gsapAnimate(
      this.cs.previewShape as FileRootShape,
      true,
    );
    this.animationService.timeLine.eventCallback('onComplete', () => {
      setTimeout(() => {
        this.cs.previewShape.reset();
        this.cs.canvasContainer.addChild(this.cs.previewShape.rootContainer);
        this.textShape?.reset();
        this.animationService.animationState = 'idle';
        this.isPlaying = false;
      }, 1000);
    });
  }

  addTextAnimation(index: number) {
    let next = cloneDeep(this.baseStep);

    const steps = [];
    let i = 0;
    while (next) {
      steps.push(next);
      next = next.next;
      if (i == index) {
        steps.push({
          type: 'appear',
          duration: 1,
          zoom: {
            // think of the //
            type: 'absolute',
            from: 0.5,
            to: 1,
          },
        });
      }
      i++;
    }

    console.log('afterAdd', steps);
    steps.reverse();
    // -- // -- //
    const newValue = steps.reduce((prev, step) => {
      if (!prev) {
        return step;
      }
      step.next = prev;
      return step;
    }, null);

    this.store.dispatch(
      setFileDescriptorItem({
        key: 'textAnimationStep',
        value: newValue as TextAnimationStep,
      }),
    );
  }

  _frames?: Record<string, TextAnimationFrameObject> = {};
  // Frame graph helpers and editing
  private rebuildFrames(step: TextAnimationStep | undefined) {
    this.frameRoot = new TextAnimationFrameObject(step, this._frames);
    // select first by default
    this.currentFrame = this.frameRoot;
  }

  selectFrame(node: TextAnimationFrameObject) {
    this.currentFrame = node;
  }

  openEdit(node: TextAnimationFrameObject) {
    this.editing = { node, draft: cloneDeep(node.frame) };
  }

  closeEdit() {
    this.editing = undefined;
  }

  applyEdit(updated: TextAnimationStep) {
    if (!this.baseStep || !this.editing) return;
    const newRoot = this.applyUpdateAtPosition(
      this.baseStep as TextAnimationStep,
      this.editing.node.col,
      this.editing.node.row,
      updated,
    );
    this.store.dispatch(
      setFileDescriptorItem({ key: 'textAnimationStep', value: newRoot }),
    );
    this.editing = undefined;
  }

  addNextAt(node: TextAnimationFrameObject) {
    if (!this.baseStep) return;
    const newStep: TextAnimationStep = { type: 'appear', duration: 1 } as any;
    const root = cloneDeep(this.baseStep as TextAnimationStep);
    const target = this.getStepAt(root, node.col, node.row);
    if (!target) return;
    newStep.next = target.next;
    target.next = newStep;
    this.store.dispatch(
      setFileDescriptorItem({ key: 'textAnimationStep', value: root }),
    );
  }

  addParalellAt(node: TextAnimationFrameObject) {
    if (!this.baseStep) return;
    const newStep: TextAnimationStep = { type: 'appear', duration: 1 } as any;
    const root = cloneDeep(this.baseStep as TextAnimationStep);
    const target = this.getStepAt(root, node.col, node.row);
    if (!target) return;
    newStep.paralell = target.paralell;
    target.paralell = newStep;
    this.store.dispatch(
      setFileDescriptorItem({ key: 'textAnimationStep', value: root }),
    );
  }

  private getStepAt(
    root: TextAnimationStep,
    col: number,
    row: number,
  ): TextAnimationStep | undefined {
    let cur: TextAnimationStep | undefined = root;
    let i = 0;
    while (cur && i < col) {
      cur = cur.next;
      i++;
    }
    let j = 0;
    while (cur && j < row) {
      cur = cur.paralell as TextAnimationStep;
      j++;
    }
    return cur;
  }

  private applyUpdateAtPosition(
    root: TextAnimationStep,
    col: number,
    row: number,
    updated: TextAnimationStep,
  ) {
    const newRoot = cloneDeep(root);
    const target = this.getStepAt(newRoot, col, row);
    if (!target) return newRoot;
    const keepNext = target.next;
    const keepPar = target.paralell;
    // replace fields
    const replacement = cloneDeep(updated) as any;
    replacement.next = keepNext;
    replacement.paralell = keepPar;
    // clear target
    for (const k of Object.keys(target as any)) delete (target as any)[k];
    Object.assign(target as any, replacement);
    return newRoot;
  }

  get playingStep(): TextAnimationStep | undefined {
    return this.baseStep as TextAnimationStep;
  }

  // helpers
  private ensure<K extends keyof TextAnimationStep>(key: K, init: any) {
    (this.model as any)[key] = (this.model as any)[key] ?? init;
  }
  private ensureObj<T extends object>(obj: any, key: string) {
    obj[key] = obj[key] ?? {};
  }

  saveType(type: TextAnimationStep['type']) {
    this.model.type = type;
    this.save();
  }

  // zoom helpers
  enableZoom(on: boolean) {
    if (on) this.ensure('zoom', {} as ZoomDefinition);
    else this.model.zoom = undefined;
    this.save();
  }

  setZoom(key: 'from' | 'to', value: number) {
    this.ensure('zoom', {} as ZoomDefinition);
    (this.model.zoom as any)[key] = value;
    // -- //
    this.save();
  }

  saveWordType(type: TextAnimationStep['word']['type']) {
    // -- //
    this.model.word ||= {};
    this.model.word.type = type;
    this.save();
  }

  isArray(value: any) {
    return Array.isArray(value);
  }

  setZoomType(type: 'absolute' | 'relative') {
    this.model.zoom.type = type;
    this.save();
  }
  setZoomTranslate(idx: 0 | 1, value: number) {
    this.ensure('zoom', {} as ZoomDefinition);
    (this.model.zoom as any).translate = (this.model.zoom as any).translate || [
      0, 0,
    ];
    (this.model.zoom as any).translate[idx] = value;
    this.save();
  }
  // translate helpers
  enableTranslate(on: boolean, noSave = false) {
    if (on)
      this.model.translate =
        this.model.translate || ({ type: 'relative' } as TranslateDefinition);
    else this.model.translate = undefined;
    if (noSave) {
      return;
    }
    this.save();
  }
  setTranslatePair(which: 'from' | 'to', idx: 0 | 1, value: number) {
    this.enableTranslate(true, true);
    (this.model.translate as any)[which] = (this.model.translate as any)[
      which
    ] || [0, 0];
    (this.model.translate as any)[which][idx] = value;
    this.save();
  }
  // line helpers
  toggleLine(on: boolean, noSave = false) {
    console.log('toggleLine', on);
    if (on) this.model.line ||= {};
    else this.model.line = undefined;
    if (noSave) {
      return;
    }
    this.save();
  }
  setLineSegmentMode(mode: 'single' | 'range') {
    this.toggleLine(true, true);
    console.log('setSegmentLineMode', this.model.line);
    (this.model.line as any).segment = mode === 'single' ? 0 : [0, 0];
    this.save();
  }
  setLineSegmentValue(val: number) {
    this.toggleLine(true, true);
    (this.model.line as any).segment = val;
    this.save();
  }
  setLineSegmentRange(idx: 0 | 1, val: number) {
    this.toggleLine(true, true);
    const seg = (this.model.line as any).segment;
    (this.model.line as any).segment = Array.isArray(seg) ? seg : [0, 0];
    ((this.model.line as any).segment as [number, number])[idx] = val;
    this.save();
  }
  lineEnsureZoom() {
    this.toggleLine(true);
    this.ensureObj(this.model.line, 'zoom');
  }
  lineSetZoomTranslate(idx: 0 | 1, val: number) {
    this.lineEnsureZoom();
    (this.model.line as any).zoom.translate = (this.model.line as any).zoom
      .translate || [0, 0];
    (this.model.line as any).zoom.translate[idx] = val;
  }
  lineEnsureTranslate() {
    this.toggleLine(true);
    this.ensureObj(this.model.line, 'translate');
  }
  lineSetTranslate(which: 'from' | 'to', idx: 0 | 1, val: number) {
    this.lineEnsureTranslate();
    (this.model.line as any).translate[which] = (this.model.line as any)
      .translate[which] || [0, 0];
    (this.model.line as any).translate[which][idx] = val;
  }
  // word helpers
  toggleWord(on: boolean, noSave = false) {
    if (on) this.model.word = this.model.word || ({ type: 'fade' } as any);
    else this.model.word = undefined;
    if (noSave) {
      return;
    }
    this.save();
  }
  setWordSegmentMode(mode: 'single' | 'range') {
    this.toggleWord(true, true);
    (this.model.word as any).segment = mode === 'single' ? 0 : [0, 0];
  }
  setWordSegmentValue(val: number) {
    this.toggleWord(true, true);
    (this.model.word as any).segment = val;
  }
  setWordSegmentRange(idx: 0 | 1, val: number) {
    this.toggleWord(true, true);
    const seg = (this.model.word as any).segment;
    (this.model.word as any).segment = Array.isArray(seg) ? seg : [0, 0];
    ((this.model.word as any).segment as [number, number])[idx] = val;
  }
  setWordZoom(idx: 0 | 1, val: number) {
    this.toggleWord(true, true);
    (this.model.word as any).zoom = (this.model.word as any).zoom || [0, 0];
    (this.model.word as any).zoom[idx] = val;
  }
  wordEnsureTranslate() {
    this.toggleWord(true, true);
    this.ensureObj(this.model.word, 'translate');
  }
  wordSetTranslate(which: 'from' | 'to', idx: 0 | 1, val: number) {
    this.wordEnsureTranslate();
    (this.model.word as any).translate[which] = (this.model.word as any)
      .translate[which] || [0, 0];
    (this.model.word as any).translate[which][idx] = val;
  }
  // action helpers
  toggleAction(on: boolean) {
    if (on) this.model.action = this.model.action || {};
    else this.model.action = undefined;
  }
  togglePulse(on: boolean) {
    this.toggleAction(true);
    if (on)
      (this.model.action as any).pulse = (this.model.action as any).pulse || {
        zoom: [0, 0],
        cnt: 1,
      };
    else (this.model.action as any).pulse = undefined;
  }
  toggleColorize(on: boolean) {
    this.toggleAction(true);
    if (on)
      (this.model.action as any).colorize = (this.model.action as any)
        .colorize || { gradient: [] };
    else (this.model.action as any).colorize = undefined;
  }
  toggleGlove(on: boolean) {
    this.toggleAction(true);
    if (on)
      (this.model.action as any).glove = (this.model.action as any).glove || {
        letterLength: 1,
        color: '#ffffff',
      };
    else (this.model.action as any).glove = undefined;
  }

  saveOverlap() {
    console.log('saveOverlap', this.model.overlap);
    this.save();
  }

  setColorizeGradientString(val: string) {
    this.toggleColorize(true);
    (this.model.action as any).colorize.gradient = val
      .split(',')
      .map(s => s.trim())
      .filter(Boolean);
  }
  getColorizeGradientString(): string {
    return ((this.model.action as any)?.colorize?.gradient || []).join(', ');
  }

  // chain
  addNext() {
    this.model.next = this.model.next || ({} as TextAnimationStep);
  }
  addParalell() {
    this.model.paralell = this.model.paralell || ({} as TextAnimationStep);
  }
}
